<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'view-oracle-order',
};
</script>
